import {
  resolveRatingLabel,
  RatingLabelResult,
} from '../../utils/resolve-rating-label'

export class CheckinStatusLabelVm {
  private resolved: RatingLabelResult

  constructor(
    status: string | null,
    statusLabel?: string | null,
    statusColor?: string | null
  ) {
    this.resolved = resolveRatingLabel({ status, statusLabel, statusColor })
  }

  // CSS custom property value for the --rating-color variable.
  // When present the SCSS rules pick this up automatically.
  get ratingColor(): string | null {
    return this.resolved.color
  }

  get text(): string | undefined {
    return this.resolved.text
  }
}
